/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_IntroInputs */

const en_to_typescript_ref_intro = /** @type {(inputs: To_Typescript_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every row is a real inference this tool performs. The last three are the ones that need your attention after copying.`)
};

const ko_to_typescript_ref_intro = /** @type {(inputs: To_Typescript_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 행은 이 도구가 실제로 수행하는 추론입니다. 마지막 세 개는 복사한 뒤 손을 봐야 하는 것들입니다.`)
};

const ja_to_typescript_ref_intro = /** @type {(inputs: To_Typescript_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行はこのツールが実際に行う推論です。最後の 3 つはコピーした後で手を入れる必要があるものです。`)
};

/**
* | output |
* | --- |
* | "Every row is a real inference this tool performs. The last three are the ones that need your attention after copying." |
*
* @param {To_Typescript_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_intro = /** @type {((inputs?: To_Typescript_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_intro(inputs)
	if (locale === "ko") return ko_to_typescript_ref_intro(inputs)
	return ja_to_typescript_ref_intro(inputs)
});